import { lazy, Suspense } from "react";
import { USER_ROUTES } from "../constants/appRoutes";
import { Route, Routes } from "react-router-dom";
import Loader from "../components/Loader";
import PrivateRoute from "./PrivateRoute";
const EmiCalculator = lazy(() => import("../pages/customer/EmiCalculator"));

const PageNotFound = lazy(
  () => import("../pages/customer/PageNotFound/PageNotFound")
);
const ReelFilterSingleReel = lazy(
  () => import("../pages/customer/Reels/Filter/SingleReel")
);
const UserAgreementPage = lazy(() => import("../pages/customer/UserAgreement"));
const SalesDataPage = lazy(() => import("../pages/customer/SalesData"));
const AdvertisePage = lazy(() => import("../pages/customer/Advertise"));
const CustomerAboutUsPage = lazy(() => import("../pages/customer/AboutUs"));
const ContactPage = lazy(() => import("../pages/customer/ContactUs/Contact"));
const HelpCenterPage = lazy(
  () => import("../pages/customer/HelpCenter/HelpCenter")
);
const MenuListSection = lazy(
  () => import("../pages/customer/Profile/MenuListSection")
);
const PropertyInformationPage = lazy(
  () => import("../pages/customer/Property/Information/PropertyInformation")
);
const CustomerProjectFormPage = lazy(
  () => import("../pages/customer/Project/NewProjectForm")
);
const PrivacyPolicyPage = lazy(
  () => import("../pages/customer/Cms/PrivacyPolicy")
);
const TermConditionPage = lazy(
  () => import("../pages/customer/Cms/TermCondition")
);
const BlogList = lazy(() => import("../pages/customer/Blog/BlogList"));
const ViewBlog = lazy(() => import("../pages/customer/Blog/ViewBlog"));
const ProjectInformationPage = lazy(
  () => import("../pages/customer/Project/Information/ProjectInformation")
);
const AccountSecurityPage = lazy(
  () =>
    import(
      "../pages/customer/Profile/AccountSettings/AccountMenuList/AccountSecurity"
    )
);
const MultiplePropertyFormPage = lazy(
  () => import("../pages/customer/Property/MultipleForm")
);
const AccountProfilePage = lazy(
  () =>
    import(
      "../pages/customer/Profile/AccountSettings/AccountMenuList/AccountProfilePage"
    )
);
const PurchasedProperty = lazy(
  () =>
    import(
      "../pages/customer/Profile/AccountSettings/AccountMenuList/PurchasedProperty"
    )
);
const PurchasedPropertyDetails = lazy(
  () =>
    import(
      "../pages/customer/Profile/AccountSettings/AccountMenuList/PurchasedPropertyDetails"
    )
);
const AccountDocumentPreferencesPage = lazy(
  () =>
    import(
      "../pages/customer/Profile/AccountSettings/AccountMenuList/AccountDocumentPreferences"
    )
);
const SavedPropertyPage = lazy(
  () => import("../pages/customer/Profile/SaveProperty/SavedPropertyPage")
);
const SavedProjectPage = lazy(
  () => import("../pages/customer/Profile/SavedProject/SavedProject")
);
// const SavedSearchesPage = lazy(
//   () => import("../pages/customer/Profile/SavedSearches/SavedSearchesPage")
// );
const ManageToursPage = lazy(
  () => import("../pages/customer/Profile/ManageTours/ManageToursPage")
);
const RecentlyViewsPage = lazy(
  () => import("../pages/customer/Profile/RecentlyViews/RecentlyViewsPage")
);

const YourPropertyPage = lazy(
  () => import("../pages/customer/Profile/YourProperty/YourPropertyPage")
);
const YourProjectPage = lazy(
  () => import("../pages/customer/Profile/YourProject/YourProjectPage")
);
const ArchivedProperty = lazy(
  () => import("../pages/customer/Profile/YourProperty/ArchivedProperty")
);
const ArchivedProject = lazy(
  () => import("../pages/customer/Profile/YourProject/ArchivedProject")
);
const AccountSettingPage = lazy(
  () => import("../pages/customer/Profile/AccountSettings/AccountSettingPage")
);
const SearchPropertyPage = lazy(
  () => import("../pages/customer/Search/SearchProperty")
);
const ViewTour = lazy(
  () => import("../pages/customer/Profile/ManageTours/ViewTour")
);
const Verification = lazy(() => import("../pages/customer/Auth/Verification"));
const Reels = lazy(() => import("../pages/customer/Reels/Reels"));
const ReelFilterPage = lazy(
  () => import("../pages/customer/Reels/Filter/ReelFilter")
);

const CustomerRoutes = ({ serverProps }: any) => {
  return (
    <Suspense
      fallback={
        <div className="flex justify-center items-center h-[100vh] customer-routes">
          <Loader />
        </div>
      }
    >
      <Routes>
        <Route path={USER_ROUTES.PROFILE} element={<>profile</>} />
        <Route path={USER_ROUTES.VERIFY} element={<Verification />} />
        <Route path={USER_ROUTES.SEARCH} element={<SearchPropertyPage />} />
        <Route
          path={USER_ROUTES.SAVED_PROPERTY}
          element={
            <PrivateRoute>
              <MenuListSection>
                <SavedPropertyPage />
              </MenuListSection>
            </PrivateRoute>
          }
        />
        <Route
          path={USER_ROUTES.SAVED_PROJECT}
          element={
            <PrivateRoute>
              <MenuListSection>
                <SavedProjectPage />
              </MenuListSection>
            </PrivateRoute>
          }
        />
        <Route
          path={USER_ROUTES.MANAGE_TOURS}
          element={
            <PrivateRoute>
              <MenuListSection>
                <ManageToursPage />
              </MenuListSection>
            </PrivateRoute>
          }
        />

        <Route
          path={USER_ROUTES.VIEW_MEETING}
          element={
            <PrivateRoute>
              <MenuListSection>
                <ViewTour />
              </MenuListSection>
            </PrivateRoute>
          }
        />
        <Route
          path={USER_ROUTES.RECENTLY_VIEWED}
          element={
            <PrivateRoute>
              <MenuListSection>
                <RecentlyViewsPage />
              </MenuListSection>
            </PrivateRoute>
          }
        />
        <Route
          path={USER_ROUTES.YOUR_PROPERTY}
          element={
            <PrivateRoute>
              <MenuListSection>
                <YourPropertyPage />
              </MenuListSection>
            </PrivateRoute>
          }
        />
        <Route
          path={USER_ROUTES.YOUR_NEW_PROPERTY}
          element={
            <PrivateRoute>
              <MenuListSection>
                <MultiplePropertyFormPage />
              </MenuListSection>
            </PrivateRoute>
          }
        />
        <Route
          path={USER_ROUTES.EDIT_YOUR_PROPERTY}
          element={
            <PrivateRoute>
              <MenuListSection>
                <MultiplePropertyFormPage />
              </MenuListSection>
            </PrivateRoute>
          }
        />
        <Route
          path={USER_ROUTES.YOUR_PROJECT}
          element={
            <PrivateRoute>
              <MenuListSection>
                <YourProjectPage />
              </MenuListSection>
            </PrivateRoute>
          }
        />
        <Route
          path={USER_ROUTES.YOUR_NEW_PROJECT}
          element={
            <PrivateRoute>
              <MenuListSection>
                <CustomerProjectFormPage />
              </MenuListSection>
            </PrivateRoute>
          }
        />
        <Route
          path={USER_ROUTES.EDIT_YOUR_PROJECT}
          element={
            <PrivateRoute>
              <MenuListSection>
                <CustomerProjectFormPage />
              </MenuListSection>
            </PrivateRoute>
          }
        />

        <Route
          path={USER_ROUTES.ARCHIVED_PROPERTY}
          element={
            <PrivateRoute>
              <MenuListSection>
                <ArchivedProperty />
              </MenuListSection>
            </PrivateRoute>
          }
        />
        <Route
          path={USER_ROUTES.ARCHIVED_PROJECT}
          element={
            <PrivateRoute>
              <MenuListSection>
                <ArchivedProject />
              </MenuListSection>
            </PrivateRoute>
          }
        />
        <Route
          path={USER_ROUTES.ACCOUNT_SETTINGS}
          element={
            <PrivateRoute>
              <MenuListSection>
                <AccountSettingPage />
              </MenuListSection>
            </PrivateRoute>
          }
        />
        <Route path={USER_ROUTES.ABOUT_US} element={<CustomerAboutUsPage />} />
        <Route
          path={USER_ROUTES.ACCOUNT_SETTINGS_PROFILE}
          element={
            <PrivateRoute>
              <AccountProfilePage />
            </PrivateRoute>
          }
        />
        <Route
          path={USER_ROUTES.ACCOUNT_SETTINGS_SECURITY}
          element={
            <PrivateRoute>
              <AccountSecurityPage />
            </PrivateRoute>
          }
        />
        <Route
          path={USER_ROUTES.ACCOUNT_SETTINGS_PURCHASED}
          element={
            <PrivateRoute>
              <PurchasedProperty />{" "}
            </PrivateRoute>
          }
        />
        <Route
          path={USER_ROUTES.ACCOUNT_SETTINGS_PURCHASED_ID}
          element={
            <PrivateRoute>
              <PurchasedPropertyDetails />
            </PrivateRoute>
          }
        />
        <Route
          path={USER_ROUTES.ACCOUNT_SETTINGS_PROFILE}
          element={
            <PrivateRoute>
              <AccountDocumentPreferencesPage />
            </PrivateRoute>
          }
        />
        <Route path={USER_ROUTES.BLOG_LIST} element={<BlogList />} />
        <Route path={USER_ROUTES.BLOG_SINGLE} element={<ViewBlog />} />
        <Route
          path={USER_ROUTES.PROPERTY_INFORMATION_ID}
          element={<PropertyInformationPage serverProps={serverProps} />}
        />
        <Route
          path={USER_ROUTES.TERM_AND_CONDITIONS}
          element={<TermConditionPage />}
        />
        <Route
          path={USER_ROUTES.PRIVACY_POLICY}
          element={<PrivacyPolicyPage />}
        />
        <Route
          path={USER_ROUTES.TERM_AND_CONDITIONS}
          element={<TermConditionPage />}
        />
        <Route
          path={USER_ROUTES.PRIVACY_POLICY}
          element={<PrivacyPolicyPage />}
        />
        <Route path={USER_ROUTES.CONTACT_US} element={<ContactPage />} />
        <Route path={USER_ROUTES.HELP_CENTER} element={<HelpCenterPage />} />

        <Route path={USER_ROUTES.MENU_ADVERTISE} element={<AdvertisePage />} />

        <Route
          path={USER_ROUTES.PROJECT_INFORMATION_ID}
          element={<ProjectInformationPage serverProps={serverProps} />}
        />

        <Route path={USER_ROUTES.SALES_DATA} element={<SalesDataPage />} />

        <Route path={USER_ROUTES.REELS} element={<Reels />} />
        <Route
          path={USER_ROUTES.REELS_FILTER_PARAMS}
          element={<ReelFilterPage />}
        />
        <Route
          path={USER_ROUTES.REELS_FILTER_REEL_PARAMS}
          element={<ReelFilterSingleReel />}
        />
        <Route path={USER_ROUTES.REEL_ID} element={<Reels />} />
        <Route
          path={USER_ROUTES.USER_AGREEMENT}
          element={<UserAgreementPage />}
        />
        <Route path={USER_ROUTES.EMI_CALCULATOR} element={<EmiCalculator />} />

        <Route path={USER_ROUTES.NOT_FOUND} element={<PageNotFound />} />
      </Routes>
    </Suspense>
  );
};

export default CustomerRoutes;
